export interface PrioritizedCatalogItem { id: string; displayPriority?: number; createdAt?: string }

export function compareCatalogPriority(left: PrioritizedCatalogItem, right: PrioritizedCatalogItem): number {
  const priority = (left.displayPriority ?? 0) - (right.displayPriority ?? 0);
  if (priority) return priority;
  const created = (left.createdAt || '').localeCompare(right.createdAt || '');
  return created || left.id.localeCompare(right.id);
}

export function sortByDisplayPriority<T extends PrioritizedCatalogItem>(items: T[]): T[] {
  return [...items].sort(compareCatalogPriority);
}

